import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import { EndPoints, getAuthHeader, getBaseUrl, getImageUrl, UploadType } from '../../api';
import { createProduct, updateProduct } from '../../api/products';
import { Button } from '../../components/Button';
import { Dropdown } from '../../components/Dropdown';
import { Modal } from '../../components/Modal';
import { CloseIcon } from '../../icons/CloseIcon';
import { Color } from '../../utils/color';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './products.styl';
var ProductsDetailsModal = /** @class */ (function (_super) {
    __extends(ProductsDetailsModal, _super);
    function ProductsDetailsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            titleInputError: false,
            imageInputError: false,
            photoInputError: false,
            formatInputError: false,
            instructionInputError: false,
            descriptionInputError: false,
            featuresInputError: false,
            indicationsInputError: false,
            instructionEditorState: '',
            descriptionEditorState: '',
            featuresEditorState: '',
            indicationsEditorState: '',
            activeFormats: [],
        };
        _this.dropZoneImage = null;
        _this.dropZonePhoto = null;
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleInputError: false });
            }
        };
        _this.onChangeFormatAction = function (e, index) {
            var name = e.currentTarget.name;
            var format = _this.state.activeFormats[index];
            if (name === "format" + index) {
                format.format = e.currentTarget.value;
            }
            if (name === "quantity" + index) {
                format.quantity = e.currentTarget.value;
            }
            if (name === "orderNumber" + index) {
                format.orderNumber = e.currentTarget.value;
            }
            if (name === "zIndexNumber" + index) {
                format.zIndexNumber = e.currentTarget.value;
            }
            var activeFormats = _this.state.activeFormats;
            activeFormats[index] = format;
            var validFormats = 0;
            activeFormats.forEach(function (f) {
                if (_this.isFormatValid(f)) {
                    validFormats += 1;
                }
            });
            if (validFormats === activeFormats.length) {
                activeFormats.push(_this.getEmptyFormat());
            }
            _this.setState({
                activeFormats: activeFormats,
            });
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.onClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.onInstructionEditorStateChange = function (state) {
            _this.setState({
                instructionEditorState: state,
                instructionInputError: false,
            });
        };
        _this.onDescriptionEditorStateChange = function (state) {
            _this.setState({
                descriptionEditorState: state,
                descriptionInputError: false,
            });
        };
        _this.onFeaturesEditorChange = function (state) {
            _this.setState({
                featuresEditorState: state,
                featuresInputError: false,
            });
        };
        _this.onIndicationsEditorChange = function (state) {
            _this.setState({
                indicationsEditorState: state,
                indicationsInputError: false,
            });
        };
        _this.getUploadImageParams = function (_) {
            return {
                url: getBaseUrl() + EndPoints.upload + '?type=' + UploadType.product,
                headers: getAuthHeader(),
            };
        };
        _this.handleImageChangeStatus = function (params, status) {
            if (status === 'done') {
                var response = JSON.parse(params.xhr.response);
                _this.setState({
                    attachedImage: response.data.fileName,
                });
                _this.dropZoneImage.files = [];
            }
        };
        _this.getUploadPhotoParams = function (_) {
            return {
                url: getBaseUrl() + EndPoints.upload + '?type=' + UploadType.product,
                headers: getAuthHeader(),
            };
        };
        _this.handlePhotoChangeStatus = function (params, status) {
            if (status === 'done') {
                var response = JSON.parse(params.xhr.response);
                _this.setState({
                    attachedPhoto: response.data.fileName,
                });
                _this.dropZonePhoto.files = [];
            }
        };
        _this.onGroupChange = function (group) {
            _this.setState({
                selectedGroup: group,
            });
        };
        _this.onCloseModal = function () {
            // Block modal close
        };
        return _this;
    }
    ProductsDetailsModal.prototype.componentDidMount = function () {
        if (this.props.editProduct) {
            var _a = this.props, editProduct_1 = _a.editProduct, groups = _a.groups;
            var activeFormats = [this.getEmptyFormat()];
            if (editProduct_1.formats) {
                activeFormats = editProduct_1.formats;
                activeFormats.push(this.getEmptyFormat());
            }
            this.setState({
                instructionEditorState: editProduct_1.instructions || '',
                attachedImage: editProduct_1.image,
                attachedPhoto: editProduct_1.photo,
                descriptionEditorState: editProduct_1.description || '',
                featuresEditorState: editProduct_1.features || '',
                indicationsEditorState: editProduct_1.indications || '',
                selectedGroup: (groups || []).find(function (g) { return g.id === editProduct_1.groupId; }),
                activeFormats: activeFormats,
            });
        }
        else {
            this.setState({
                activeFormats: [this.getEmptyFormat()],
            });
        }
    };
    ProductsDetailsModal.prototype.onSubmit = function (event) {
        var _this = this;
        var _a;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        if (title.length === 0) {
            this.setState({ titleInputError: true });
            valid = false;
        }
        var instructions = this.instructionRef.getContent();
        if (isHtmlEmpty(instructions)) {
            this.setState({ instructionInputError: true });
            valid = false;
        }
        var description = this.descriptionRef.getContent();
        if (isHtmlEmpty(description)) {
            // this.setState({descriptionInputError: true});
            // valid = false;
            description = '';
        }
        var features = this.featuresRef.getContent();
        if (isHtmlEmpty(features)) {
            this.setState({ featuresInputError: true });
            valid = false;
        }
        var indications = this.indicationRef.getContent();
        if (isHtmlEmpty(indications)) {
            this.setState({ indicationsInputError: true });
            valid = false;
        }
        var image = this.state.attachedImage;
        if (!image || image.length === 0) {
            this.setState({ imageInputError: true });
            valid = false;
        }
        var photo = this.state.attachedPhoto;
        if (!photo || photo.length === 0) {
            this.setState({ photoInputError: true });
            valid = false;
        }
        var formats = this.state.activeFormats.filter(function (f) { return _this.isFormatValid(f); });
        if (!formats || formats.length === 0) {
            this.setState({ formatInputError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            title: title,
            instructions: instructions,
            description: description,
            features: features,
            indications: indications,
            image: this.state.attachedImage || '',
            photo: this.state.attachedPhoto || '',
            groupId: (_a = this.state.selectedGroup) === null || _a === void 0 ? void 0 : _a.id,
            formats: JSON.stringify(formats),
        };
        this.setState({ loading: true });
        if (this.props.editProduct) {
            request.id = this.props.editProduct.id;
            updateProduct(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
        else {
            createProduct(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
    };
    ProductsDetailsModal.prototype.isFormatValid = function (format) {
        var _a, _b, _c, _d;
        if (((_a = format.format) === null || _a === void 0 ? void 0 : _a.length) !== 0
            && ((_b = format.quantity) === null || _b === void 0 ? void 0 : _b.length) !== 0
            && ((_c = format.orderNumber) === null || _c === void 0 ? void 0 : _c.length) !== 0
            && ((_d = format.zIndexNumber) === null || _d === void 0 ? void 0 : _d.length) !== 0) {
            return true;
        }
        return false;
    };
    ProductsDetailsModal.prototype.getEmptyFormat = function () {
        return {
            format: '',
            quantity: '',
            orderNumber: '',
            zIndexNumber: '',
        };
    };
    ProductsDetailsModal.prototype.onRemoveFormat = function (_, index) {
        var newList = [];
        this.state.activeFormats.forEach(function (format, i) {
            if (index !== i) {
                newList.push(format);
            }
        });
        this.setState({
            activeFormats: newList,
        });
    };
    ProductsDetailsModal.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var editProduct = this.props.editProduct;
        var i18n = props.store.i18n;
        var loading = state.loading, instructionEditorState = state.instructionEditorState, descriptionEditorState = state.descriptionEditorState, featuresEditorState = state.featuresEditorState, indicationsEditorState = state.indicationsEditorState, activeFormats = state.activeFormats;
        return (React.createElement(Modal, { className: props.className, onRequestClose: this.onCloseModal },
            React.createElement("div", { className: S.productsAddView },
                React.createElement("p", { className: S.productsHeaderText }, editProduct ?
                    (i18n.productsUpdateTitle + (" (ID: " + (editProduct === null || editProduct === void 0 ? void 0 : editProduct.id) + ")"))
                    :
                        i18n.productsCreateTitle),
                React.createElement("form", { className: "" + S.detailsDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputTitlePlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: editProduct === null || editProduct === void 0 ? void 0 : editProduct.title })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleInputError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("p", { className: "formSubtitle" },
                            i18n.inputGroup,
                            " ",
                            i18n.inputOptional),
                        props.groups &&
                            React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: "" + (state.selectedGroup ? state.selectedGroup.title : i18n.inputChoose) },
                                React.createElement(Dropdown.List, null, props.groups.map(function (group, index) { return (React.createElement(Dropdown.Item, { key: index, data: "groupItem", autoClose: true, onClick: function (_) { return _this.onGroupChange(group); } }, group.title)); }))),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputDescriptionTitle),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.descriptionRef = editor; }, apiKey: getEditorKey(), initialValue: descriptionEditorState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.descriptionInputError ? 'inputErrorActive' : '') }, i18n.validationDescriptionError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputInstructionsTitle),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.instructionRef = editor; }, apiKey: getEditorKey(), initialValue: instructionEditorState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.instructionInputError ? 'inputErrorActive' : '') }, i18n.validationInstructionError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputFeaturesTitle),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.featuresRef = editor; }, apiKey: getEditorKey(), initialValue: featuresEditorState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.featuresInputError ? 'inputErrorActive' : '') }, i18n.validationFeaturesError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputIndicationsTitle),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.indicationRef = editor; }, apiKey: getEditorKey(), initialValue: indicationsEditorState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.indicationsInputError ? 'inputErrorActive' : '') }, i18n.validationIndicationsError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleIcon),
                        React.createElement("div", { className: "formUploadWrapper" },
                            state.attachedImage ?
                                React.createElement("img", { className: "preview", src: getImageUrl(state.attachedImage) })
                                :
                                    '',
                            React.createElement(Dropzone, { ref: function (r) { return _this.dropZoneImage = r; }, getUploadParams: this.getUploadImageParams, onChangeStatus: this.handleImageChangeStatus, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.imageInputError ? 'inputErrorActive' : '') }, i18n.validationImageError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePhoto),
                        React.createElement("div", { className: "formUploadWrapper" },
                            state.attachedPhoto ?
                                React.createElement("img", { className: "preview", src: getImageUrl(state.attachedPhoto) })
                                :
                                    '',
                            React.createElement(Dropzone, { ref: function (r) { return _this.dropZonePhoto = r; }, getUploadParams: this.getUploadPhotoParams, onChangeStatus: this.handlePhotoChangeStatus, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.photoInputError ? 'inputErrorActive' : '') }, i18n.validationImageError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputOrderInfoTitle),
                        React.createElement("div", { className: "" + S.formatWrapper },
                            React.createElement("div", { className: "" + S.formatHeader },
                                React.createElement("span", null, i18n.productsFormatFormat),
                                React.createElement("span", null, i18n.productsFormatAmount),
                                React.createElement("span", null, i18n.productsFormatOrder),
                                React.createElement("span", null, i18n.productsFormatIndex)),
                            activeFormats.map(function (format, i) { return (React.createElement("div", { key: i, className: "" + S.formatItem },
                                React.createElement("input", { className: S.detailsInput + " textInput", name: "format" + i, onInput: function (e) { _this.onChangeFormatAction(e, i); }, placeholder: i18n.productsFormatFormat, defaultValue: format === null || format === void 0 ? void 0 : format.format }),
                                React.createElement("input", { className: S.detailsInput + " textInput", name: "quantity" + i, onInput: function (e) { _this.onChangeFormatAction(e, i); }, placeholder: i18n.productsFormatAmount, defaultValue: format === null || format === void 0 ? void 0 : format.quantity }),
                                React.createElement("input", { className: S.detailsInput + " textInput", name: "orderNumber" + i, onInput: function (e) { _this.onChangeFormatAction(e, i); }, placeholder: i18n.productsFormatOrder, defaultValue: format === null || format === void 0 ? void 0 : format.orderNumber }),
                                React.createElement("input", { className: S.detailsInput + " textInput", name: "zIndexNumber" + i, onInput: function (e) { _this.onChangeFormatAction(e, i); }, placeholder: i18n.productsFormatIndex, defaultValue: format === null || format === void 0 ? void 0 : format.zIndexNumber }),
                                _this.isFormatValid(format) &&
                                    React.createElement(Button, { className: "" + S.removeButton, type: "button", onClick: function (e) { _this.onRemoveFormat(e, i); } },
                                        React.createElement(CloseIcon, { color: Color.Error })))); })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.formatInputError ? 'inputErrorActive' : '') }, i18n.validationOrderInfoError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.productsModalButton, type: "submit", spinner: loading }, editProduct ?
                        i18n.actionUpdate
                        :
                            i18n.actionCreate),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.productsModalButton + " " + S.productsModalCancel, type: "button", spinner: loading, onClick: this.onClose }, i18n.alertModalCancel)))));
    };
    __decorate([
        action.bound
    ], ProductsDetailsModal.prototype, "onSubmit", null);
    ProductsDetailsModal = __decorate([
        inject('store'),
        observer
    ], ProductsDetailsModal);
    return ProductsDetailsModal;
}(React.Component));
export { ProductsDetailsModal };
